import { KeyboardAvoidingView, Modal, StyleSheet, Text, View, type GestureResponderEvent } from 'react-native';
import { HelperText } from 'react-native-paper';
import Translations from 'src/core/utils/Translations';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import LoadingOverlay from 'src/presentation/components/molecules/LoadingOverlay';
import PasswordField from 'src/presentation/components/molecules/PasswordField';

interface Props {
	buttonText?: string;
	buttonTextClaim?: string;
	errorPassword?: string | null;
	isLoading?: boolean;
	isPasswordVisible: boolean;
	onPress: (event: GestureResponderEvent) => void;
	onPressClaim?: (event: GestureResponderEvent) => void;
	onPressForgotPassword: (event: GestureResponderEvent) => void;
	password: string;
	setPassword: (password: string) => void;
	setPasswordVisible: (isPasswordVisible: boolean) => void;
	text?: string;
	title?: string;
	visible?: boolean;
}

const DeleteAccountDialog = ({
	buttonText = Translations.cancel,
	buttonTextClaim = Translations.delete,
	errorPassword,
	isLoading,
	isPasswordVisible,
	onPress,
	onPressClaim,
	onPressForgotPassword,
	password,
	setPassword,
	setPasswordVisible,
	text,
	title,
	visible,
}: Props) => {
	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={visible}>
			<KeyboardAvoidingView behavior="padding" style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					{isLoading ? <LoadingOverlay /> : null}
					{title ? <Text style={[dialogStyles.modalTitle, styles.centeredTitle]}>{title}</Text> : null}
					{text ? <Text style={dialogStyles.modalDescription}>{text}</Text> : null}

					<PasswordField
						hasError={!!errorPassword}
						isVisible={isPasswordVisible}
						label={Translations.currentPassword}
						value={password}
						onChangeText={setPassword}
						onVisibilityChange={setPasswordVisible}
					/>

					<HelperText type="error" visible={!!errorPassword}>
						{errorPassword}
					</HelperText>

					<Text style={styles.forgotPasswordLink} onPress={onPressForgotPassword}>
						{Translations.loginForgotPasswordLink}
					</Text>

					<View style={{ flexDirection: 'row' }}>
						<SecondaryButton
							extraStyle={{ paddingHorizontal: Dimens.padding10, flex: Dimens.flex1 }}
							label={buttonText}
							onPress={onPress}
						/>
						<PrimaryButton
							extraStyle={{ paddingHorizontal: Dimens.padding10, flex: Dimens.flex1 }}
							label={buttonTextClaim}
							onPress={onPressClaim}
						/>
					</View>
				</View>
			</KeyboardAvoidingView>
		</Modal>
	);
};

const styles = StyleSheet.create({
	centeredTitle: {
		textAlign: 'center',
	},
	forgotPasswordLink: {
		textAlign: 'center',
		textDecorationLine: 'underline',
		color: Colors.green,
		marginBottom: Dimens.padding20,
	},
});

export default DeleteAccountDialog;
